import type { V2CreateAdminWorkflowInput } from '@idc-forms/schemas/api-v2/admin-workflows'
import { useSidePanelStore } from '@/shared/store/side-panel.store'
import { useCreateWorkflowV2Mutation } from '../hooks/use-workflow-v2-mutations'
import { WorkflowV2Form } from './workflow-v2-form'

type WorkflowV2CreatePanelProps = {
  onDone?: () => void
}

/** "Nuevo flujo de trabajo" contra la API v2: el mismo WorkflowV2Form que la edición. */
export function WorkflowV2CreatePanel({ onDone }: WorkflowV2CreatePanelProps) {
  const closePanel = useSidePanelStore((s) => s.closePanel)
  const createMutation = useCreateWorkflowV2Mutation()
  const done = onDone ?? closePanel

  const handleSubmit = (values: V2CreateAdminWorkflowInput) => {
    createMutation.mutate(values, {
      onSuccess: () => {
        done()
      }
    })
  }

  return (
    <WorkflowV2Form
      submitLabel="Crear flujo de trabajo"
      pending={createMutation.isPending}
      onSubmit={handleSubmit}
      onCancel={done}
    />
  )
}
